export const corianderGreen = '#27ae60'; // Original #f44336
